import { useSelector } from 'react-redux'
import { useRef, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import TextField from '../../../../../FormLegacy/FormFieldsV2/TextField'
import { ToggleField } from '../../../../../FormLegacy/FormFieldsV2/ToggleField'
import { ActivateAnnouncementNumberCard } from '../ActivateAnnouncementNumberCard/ActivateAnnouncementNumberCard'
import { selectActiveBuilding } from '../../../../../../reducers/buildingSelectorReducer'
import { getSMScounter } from '../../../../../../firebase/privateChat/firebaseActions'

export const OptionalSmsSection = ({ formState, setFormState }) => {
  const { t } = useTranslation(['rewards-gift'])
  const selectedBuilding = useSelector(selectActiveBuilding)
  const recipientPhoneTouched = useRef(false)
  const [hasNoSMSCreditLeft, setNoHasSMSCreditLeft] = useState(false)

  const shouldShowNoCreditsAlert = formState.sendSms && hasNoSMSCreditLeft
  const shouldShowPhoneNumberInput = formState.nonResident && formState.sendSms
  const shouldShowActivateSmsPanel = !selectedBuilding?.announcementPhone
  const isRecipentPhoneValid = formState.recipientPhone?.length === 10

  const checkSMSCounter = async () => {
    if (!selectedBuilding.id) {
      return
    }

    try {
      const count = await getSMScounter(selectedBuilding.id)
      setNoHasSMSCreditLeft(count <= 0)
    } catch {
      setNoHasSMSCreditLeft(true)
    }
  }

  useEffect(() => {
    checkSMSCounter()
  }, [selectedBuilding])

  return (
    <>
      <div className="card-summary-sms-input">
        <span>{t('rewards-gift:optionalSms.notifyRecipientViaSmsLabel')}</span>
        <ToggleField
          name="table-toggle"
          value={formState.sendSms}
          disabled={shouldShowActivateSmsPanel}
          onChange={() => {
            setFormState((prevState) => ({
              ...prevState,
              sendSms: !prevState.sendSms,
              recipientPhone: '',
            }))
          }}
        />
      </div>
      {!shouldShowNoCreditsAlert && shouldShowPhoneNumberInput && (
        <div className="card-summary-non-resident-phone-input">
          <p className="card-summary-non-resident-phone-input-label">
            {t('rewards-gift:optionalSms.recipentMobileNumberLabel')}
          </p>
          <TextField
            name="recipientPhone"
            value={formState.recipientPhone}
            errorLabel={t('rewards-gift:optionalSms.recipientMobileRequiredError')}
            isError={recipientPhoneTouched.current && !isRecipentPhoneValid}
            style={{ width: '100%' }}
            onChange={(e) => {
              const onlyNumbers = e.target.value.replace(/\D/g, '')

              if (onlyNumbers.length > 10) {
                return
              }

              setFormState((prevState) => ({
                ...prevState,
                recipientPhone: onlyNumbers,
              }))
            }}
            onBlur={() => {
              recipientPhoneTouched.current = true
            }}
          />
          <span className="input-prefix">+1</span>
        </div>
      )}
      {shouldShowNoCreditsAlert && (
        <div className="no-credits-left">{t('rewards-gift:optionalSms.noCreditsLeftInfo')}</div>
      )}
      {!shouldShowNoCreditsAlert && shouldShowActivateSmsPanel && (
        <ActivateAnnouncementNumberCard />
      )}
    </>
  )
}
